import React from "react";
import { Box, Image, Text, Stack, useColorModeValue } from "@chakra-ui/react";
import loadingRing from '../../assets/errorandloading/Group.png'; 

const Loading = () => {
  const bg = useColorModeValue("#f2eee8", "gray.800");

  return (
    <Box
      bg={bg}
      minH="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={4}
    >
      <Stack spacing={4} align="center">
        <Image
          src={loadingRing}
          alt="loading-ring"
          boxSize={["80px", "100px", "130px"]}
        />
        <Text
          fontSize={["sm", "md"]}
          color="gray.700"
          fontWeight="medium"
          whiteSpace="nowrap"
        >
          Loading please wait<span style={{ letterSpacing: "1px" }}>....................</span>
        </Text>
      </Stack>
    </Box>
  );
};

export default Loading;
